import axiosInstance from "../modules/axiosInstance";
import axios from "axios"; // para el PUT firmado (sin baseURL ni interceptores)

const UploadsService = {
  init: async (payload) => {
    const { data } = await axiosInstance.post("api/uploads/init", payload);
    return data;
  },

  getPartUrl: async (params) => {
    const { data } = await axiosInstance.get("api/uploads/video/part-url", { params });
    return data.url;
  },

  completeMultipart: async (body) => {
    const { data } = await axiosInstance.post("api/uploads/video/complete", body);
    return data;
  },

  cancelMultipart: async (body) => {
    const { data } = await axiosInstance.post("api/uploads/video/cancel", body);
    return data;
  },

  presignNewsImage: async (fileType) => {
    const { data } = await axiosInstance.post("api/uploads/image/news", { fileType });
    return data.image;
  },


  presignPopUpImage: async (fileType) => {
    const { data } = await axiosInstance.post("api/uploads/image/popup", { fileType });
    return data.image;
  },

  // 👇 usar axios sin instancia (o fetch) para PUT a S3
  putToPresigned: async (url, file, headers = {}) => {
    await axios.put(url, file, { headers });
  },
};

export default UploadsService;
